/** 面积图*/
import React from 'react';

import { Area } from '@ant-design/charts'; 
import WidgetEchartConfig from './WidgetEchartConfig';

class WidgetEcharArea extends React.Component
{
    constructor()
    {
        super();

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);
    }

    /** event */
    onEvent(chart, event) 
    {
        if( this.props.onEvent!==undefined )
        {
            if( event.type==="element:mousedown" )
            {
                this.props.onEvent( event, event.data.data );
            } 
        } 
    }

    /** create config */
    buildConfig(option, data)
    {
        let config = {
            data : data.data,
            xField : option.xField!==undefined ? option.xField.name : 'name',
            yField : option.yField!==undefined ? option.yField.name : 'value',
            isStack:false
        };

        if( option.seriesField!==undefined )
        {
            config["seriesField"] = option.seriesField.name;
        }

        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].areaConfig, ...option, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].areaConfig, ...option, ...config};
        }

        return config;

    }

    render()
    {
        const { option, data } = this.props; 
        
        let config = this.buildConfig(option, data);

        return <Area {...config} onEvent={this.onEvent} ></Area>
    }


}

export default WidgetEcharArea;